!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("mobx"), require("mobx-state-tree")) : "function" == typeof define && define.amd ? define(["mobx", "mobx-state-tree"], t) : "object" == typeof exports ? exports.mstform = t(require("mobx"), require("mobx-state-tree")) : e.mstform = t(e.mobx, e["mobx-state-tree"]);
}(window, function (e, t) {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = {
        value: function (e) {
          return {
            value: e.raw,
            onChange: function (t) {
              return e.setRaw(t.target.value);
            }
          };
        },
        checked: function (e) {
          return {
            checked: e.raw,
            onChange: function (t) {
              return e.setRaw(t.target.checked);
            }
          };
        },
        object: function (e) {
          return {
            value: e.raw,
            onChange: function (t) {
              return e.setRaw(t);
            }
          };
        }
      },
      o = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      i = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = function () {
        return function () {};
      }(),
      s = function () {
        return function (e) {
          this.value = e;
        };
      }(),
      u = function () {
        function e(e) {
          this.definition = e, this.neverRequired = !1, this.emptyRaw = e.emptyRaw, this.emptyImpossible = !!e.emptyImpossible;
          var t = e.emptyValue;
          if (this.emptyImpossible) {
            if (void 0 !== t) throw new Error("If you set emptyImpossible for a converter, emptyValue cannot be set");
            this.emptyValue = void 0;
          } else this.emptyValue = t;
          this.defaultControlled = e.defaultControlled ? e.defaultControlled : r.object, this.neverRequired = !!e.neverRequired;
        }
        return e.prototype.preprocessRaw = function (e, t) {
          return null == this.definition.preprocessRaw ? e : this.definition.preprocessRaw(e, t);
        }, e.prototype.convert = function (e, t) {
          return o(this, void 0, void 0, function () {
            var n, r;
            return i(this, function (o) {
              switch (o.label) {
                case 0:
                  return this.definition.rawValidate ? [4, this.definition.rawValidate(e, t)] : [3, 2];
                case 1:
                  if (!o.sent()) return [2, "ConversionError"];
                  o.label = 2;
                case 2:
                  return o.trys.push([2, 5,, 6]), n = this.definition.convert(e, t), this.definition.validate ? [4, this.definition.validate(n, t)] : [3, 4];
                case 3:
                  if (!o.sent()) return [2, "ConversionError"];
                  o.label = 4;
                case 4:
                  return [2, new s(n)];
                case 5:
                  if ((r = o.sent()) instanceof a) return [2, "ConversionError"];
                  throw r;
                case 6:
                  return [2];
              }
            });
          });
        }, e.prototype.render = function (e, t) {
          return this.definition.render(e, t);
        }, e;
      }(),
      c = n(0),
      p = n(1);
    function l(e) {
      return e;
    }
    function d(e) {
      return e.startsWith("/") && (e = e.slice(1)), "" === e ? [] : e.split("/");
    }
    function f(e) {
      return Number.isInteger(parseInt(e, 10));
    }
    function y(e, t) {
      return function e(t, n) {
        var r = n[0],
          o = n.slice(1);
        if (0 === o.length) return t[r];
        var i = t[r];
        if (void 0 === i) return;
        return e(i, o);
      }(e, d(t));
    }
    function h(e, t) {
      return function e(t, n) {
        var r = n[0],
          o = n.slice(1);
        0 === o.length && delete t[r];
        var i = t[r];
        if (void 0 === i) return;
        e(i, o);
      }(e, d(t));
    }
    var g = 0,
      b = new WeakMap();
    function m(e) {
      "/" === e[0] && (e = e.slice(1));
      for (var t = [], n = 0, r = e.split("/"); n < r.length; n++) {
        var o = r[n];
        if (f(o)) {
          var i = t.pop();
          t.push(i + "[]");
        } else t.push(o);
      }
      return t.join(".");
    }
    var v = function () {
      return {};
    };
    function w(e) {
      v = e;
    }
    var O = function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      j = function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      P = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      x = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      R = function () {
        function e(e, t, n, r) {
          var o = this;
          this.state = e, this.field = t, this.parent = n, this._isValidating = !1, this._addMode = !1, this.handleChange = function () {
            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
            return P(o, void 0, void 0, function () {
              var t, n;
              return x(this, function (r) {
                switch (r.label) {
                  case 0:
                    return n = (t = this.field).getRaw.apply(t, e), [4, this.setRaw(n)];
                  case 1:
                    return r.sent(), [2];
                }
              });
            });
          }, this.handleFocus = function (e) {
            null != o.state.focusFunc && o.state.focusFunc(e, o);
          }, this.handleBlur = function (e) {
            return P(o, void 0, void 0, function () {
              return x(this, function (t) {
                return this.field.postprocess && !this._error && this.setRawFromValue(), null != this.state.blurFunc && this.state.blurFunc(e, this), [2];
              });
            });
          }, this.name = r, this.createDerivedReaction(), this._value = e.getValue(this.path);
        }
        return e.prototype.dispose = function () {
          null != this._disposer && this._disposer();
        }, e.prototype.clear = function () {
          this.dispose();
        }, Object.defineProperty(e.prototype, "path", {
          get: function () {
            return this.parent.path + "/" + this.name;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "fieldref", {
          get: function () {
            return m(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "context", {
          get: function () {
            return this.state.context;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.createDerivedReaction = function () {
          var e = this,
            t = this.field.derivedFunc;
          if (null != t && null == this._disposer) {
            var n = Object(c.reaction)(function () {
              return e.node ? t(e.node) : void 0;
            }, function (t) {
              void 0 !== t && e.setRaw(e.field.render(t, e.state.stateConverterOptionsWithContext));
            });
            this._disposer = n;
          }
        }, Object.defineProperty(e.prototype, "node", {
          get: function () {
            try {
              return this.state.getValue(this.parent.path);
            } catch (e) {
              return;
            }
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "addMode", {
          get: function () {
            return void 0 === this._raw && (this._addMode || this.parent.addMode);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "raw", {
          get: function () {
            var e = this._raw;
            return void 0 !== e ? !Object(c.isObservable)(e) || e instanceof Array ? Object(c.toJS)(e) : e : this.addMode ? this.field.converter.emptyRaw : this.field.render(this.value, this.state.stateConverterOptionsWithContext);
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.setValue = function (e) {
          this._value = e, this.state.setValueWithoutRawUpdate(this.path, e);
          var t = this.field.changeFunc;
          null != t && t(this.node, e);
          var n = this.state.updateFunc;
          null != n && n(this);
        }, Object.defineProperty(e.prototype, "value", {
          get: function () {
            if (this.addMode) throw new Error("Cannot access field in add mode until it has been set once");
            return this._value;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "errorValue", {
          get: function () {
            return void 0 === this._error ? this.state.getErrorFunc(this) : this._error;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "warningValue", {
          get: function () {
            return this.state.getWarningFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "canShowValidationMessages", {
          get: function () {
            if ("rightAfter" === this.state.saveStatus) return !0;
            var e = "before" === this.state.saveStatus ? this.state.validationBeforeSave : this.state.validationAfterSave;
            return "immediate" === e || "no" !== e && "blur" !== e && "pause" !== e;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "error", {
          get: function () {
            return this.canShowValidationMessages ? this.errorValue : void 0;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "warning", {
          get: function () {
            return this.canShowValidationMessages ? this.warningValue : void 0;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isValidating", {
          get: function () {
            return this._isValidating;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "disabled", {
          get: function () {
            return !!this.parent.disabled || this.state.isDisabledFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "hidden", {
          get: function () {
            return !!this.parent.hidden || this.state.isHiddenFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "readOnly", {
          get: function () {
            return !!this.parent.readOnly || this.state.isReadOnlyFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "inputAllowed", {
          get: function () {
            return !this.disabled && !this.hidden && !this.readOnly;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "required", {
          get: function () {
            return !this.field.converter.neverRequired && (this.field.required || this.state.isRequiredFunc(this));
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.validate = function (e) {
          return P(this, void 0, void 0, function () {
            var t, n;
            return x(this, function (r) {
              switch (r.label) {
                case 0:
                  return t = null != e && e.ignoreRequired, n = null != e && e.ignoreGetError, [4, this.setRaw(this.raw, {
                    ignoreRequired: t
                  })];
                case 1:
                  return r.sent(), n ? [2, this.isInternallyValid] : [2, this.isValid];
              }
            });
          });
        }, Object.defineProperty(e.prototype, "isInternallyValid", {
          get: function () {
            return void 0 === this._error;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isValid", {
          get: function () {
            return void 0 === this.errorValue;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "requiredError", {
          get: function () {
            return Ce(this.field.requiredError || this.state._requiredError, this.state.context);
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.setRaw = function (e, t) {
          return P(this, void 0, void 0, function () {
            var n, r, o, i, a;
            return x(this, function (s) {
              switch (s.label) {
                case 0:
                  if ("rightAfter" === this.state.saveStatus && this.state.setSaveStatus("after"), n = e, this._raw = e, r = this.state.stateConverterOptionsWithContext, e = this.field.converter.preprocessRaw(e, r), this.field.isRequired(e, this.required, t)) return this.field.converter.emptyImpossible || this.setValue(this.field.converter.emptyValue), this.setError(this.requiredError), [2];
                  this.setValidating(!0), s.label = 1;
                case 1:
                  return s.trys.push([1, 3,, 4]), [4, this.field.process(e, r)];
                case 2:
                  return o = s.sent(), [3, 4];
                case 3:
                  return s.sent(), this.setError("Something went wrong"), this.setValidating(!1), [2];
                case 4:
                  if (i = this._raw, !c.comparer.structural(i, n)) return [2];
                  if (this.setValidating(!1), o instanceof Ee) return this.setError(o.message), [2];
                  if (this.clearError(), !(o instanceof Ae)) throw new Error("Unknown process result");
                  return "string" == typeof (a = this.state.extraValidationFunc(this, o.value)) && a && this.setError(a), c.comparer.structural(this.value, o.value) ? [2] : (this.setValue(o.value), [2]);
              }
            });
          });
        }, e.prototype.setRawFromValue = function () {
          var e = this.state.getValue(this.path);
          this._value = e, this._raw = this.field.render(e, this.state.stateConverterOptionsWithContext), this.validate();
        }, e.prototype.setValueAndUpdateRaw = function (e) {
          this.setValue(e), this.setRawFromValue();
        }, e.prototype.setError = function (e) {
          this._error = e;
        }, e.prototype.clearError = function () {
          this._error = void 0;
        }, e.prototype.setValidating = function (e) {
          this._isValidating = e;
        }, Object.defineProperty(e.prototype, "inputProps", {
          get: function () {
            var e = this.field.controlled(this);
            return e.disabled = this.disabled, this.readOnly && (e.readOnly = this.readOnly), null != this.state.focusFunc && (e.onFocus = this.handleFocus), (null != this.state.blurFunc || this.field.postprocess) && (e.onBlur = this.handleBlur), e;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "validationProps", {
          get: function () {
            return v(this);
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.accessBySteps = function (e) {
          throw new Error("Cannot step through field accessor");
        }, O([c.observable, j("design:type", Object)], e.prototype, "_raw", void 0), O([c.observable, j("design:type", Object)], e.prototype, "_error", void 0), O([c.observable, j("design:type", Boolean)], e.prototype, "_isValidating", void 0), O([c.observable, j("design:type", Boolean)], e.prototype, "_addMode", void 0), O([c.observable, j("design:type", Object)], e.prototype, "_value", void 0), O([c.computed, j("design:type", String), j("design:paramtypes", [])], e.prototype, "path", null), O([c.computed, j("design:type", String), j("design:paramtypes", [])], e.prototype, "fieldref", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "context", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "node", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "addMode", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "raw", null), O([c.action, j("design:type", Function), j("design:paramtypes", [Object]), j("design:returntype", void 0)], e.prototype, "setValue", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "value", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "errorValue", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "warningValue", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "canShowValidationMessages", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "error", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "warning", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "isValidating", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "disabled", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "hidden", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "readOnly", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "inputAllowed", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "required", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "isInternallyValid", null), O([c.computed, j("design:type", Boolean), j("design:paramtypes", [])], e.prototype, "isValid", null), O([c.computed, j("design:type", String), j("design:paramtypes", [])], e.prototype, "requiredError", null), O([c.action, j("design:type", Function), j("design:paramtypes", [Object, Object]), j("design:returntype", Promise)], e.prototype, "setRaw", null), O([c.action, j("design:type", Function), j("design:paramtypes", []), j("design:returntype", void 0)], e.prototype, "setRawFromValue", null), O([c.action, j("design:type", Function), j("design:paramtypes", [Object]), j("design:returntype", void 0)], e.prototype, "setValueAndUpdateRaw", null), O([c.action, j("design:type", Function), j("design:paramtypes", [String]), j("design:returntype", void 0)], e.prototype, "setError", null), O([c.action, j("design:type", Function), j("design:paramtypes", []), j("design:returntype", void 0)], e.prototype, "clearError", null), O([c.action, j("design:type", Function), j("design:paramtypes", [Boolean]), j("design:returntype", void 0)], e.prototype, "setValidating", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "inputProps", null), O([c.computed, j("design:type", Object), j("design:paramtypes", [])], e.prototype, "validationProps", null), e;
      }(),
      F = function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      S = function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      V = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      E = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      A = function () {
        function e() {}
        return e.prototype.initialize = function () {
          this.formAccessor.initialize();
        }, e.prototype.validate = function (e) {
          return V(this, void 0, void 0, function () {
            return E(this, function (t) {
              return [2, this.formAccessor.validate(e)];
            });
          });
        }, Object.defineProperty(e.prototype, "context", {
          get: function () {
            return this.formAccessor.context;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "warningValue", {
          get: function () {
            return this.warning;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "errorValue", {
          get: function () {
            return this.error;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "error", {
          get: function () {
            return this.formAccessor.error;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "warning", {
          get: function () {
            return this.formAccessor.warning;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isValid", {
          get: function () {
            return this.formAccessor.isValid;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.access = function (e) {
          return this.formAccessor.access(e);
        }, e.prototype.accessBySteps = function (e) {
          if (0 === e.length) {
            if (null == this.formAccessor.parent) throw new Error("Unknown parent");
            return this.formAccessor.parent;
          }
          return this.formAccessor.accessBySteps(e);
        }, e.prototype.field = function (e) {
          return this.formAccessor.field(e);
        }, e.prototype.repeatingForm = function (e) {
          return this.formAccessor.repeatingForm(e);
        }, e.prototype.subForm = function (e) {
          return this.formAccessor.subForm(e);
        }, e.prototype.group = function (e) {
          return this.formAccessor.group(e);
        }, Object.defineProperty(e.prototype, "accessors", {
          get: function () {
            return this.formAccessor.accessors;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "flatAccessors", {
          get: function () {
            return this.formAccessor.flatAccessors;
          },
          enumerable: !0,
          configurable: !0
        }), F([c.computed, S("design:type", Object), S("design:paramtypes", [])], e.prototype, "context", null), F([c.computed, S("design:type", Object), S("design:paramtypes", [])], e.prototype, "warningValue", null), F([c.computed, S("design:type", Object), S("design:paramtypes", [])], e.prototype, "errorValue", null), F([c.computed, S("design:type", Object), S("design:paramtypes", [])], e.prototype, "error", null), F([c.computed, S("design:type", Object), S("design:paramtypes", [])], e.prototype, "warning", null), F([c.computed, S("design:type", Boolean), S("design:paramtypes", [])], e.prototype, "isValid", null), F([c.computed, S("design:type", Array), S("design:paramtypes", [])], e.prototype, "accessors", null), F([c.computed, S("design:type", Array), S("design:paramtypes", [])], e.prototype, "flatAccessors", null), e;
      }(),
      _ = function () {
        var e = function (t, n) {
          return (e = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          })(t, n);
        };
        return function (t, n) {
          function r() {
            this.constructor = t;
          }
          e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
        };
      }(),
      k = function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      B = function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      C = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      D = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      I = function (e) {
        function t(t, n, r, o, i) {
          var a = e.call(this) || this;
          return a.state = t, a.definition = n, a.groupDefinition = r, a.parent = o, a.name = i, a.name = i, a.formAccessor = new Y(t, n, r, a, !1), a;
        }
        return _(t, e), t.prototype.dispose = function () {}, t.prototype.clear = function () {}, t.prototype.validate = function (e) {
          return C(this, void 0, void 0, function () {
            var t, n;
            return D(this, function (r) {
              switch (r.label) {
                case 0:
                  return t = this.accessors.map(function (t) {
                    return t.validate(e);
                  }), [4, Promise.all(t)];
                case 1:
                  return n = r.sent(), null != e && e.ignoreGetError || n.push(void 0 === this.errorValue), [2, n.every(function (e) {
                    return e;
                  })];
              }
            });
          });
        }, Object.defineProperty(t.prototype, "disabled", {
          get: function () {
            return !!this.parent.disabled || this.state.isDisabledFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "hidden", {
          get: function () {
            return !!this.parent.hidden || this.state.isHiddenFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "readOnly", {
          get: function () {
            return !!this.parent.readOnly || this.state.isReadOnlyFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "inputAllowed", {
          get: function () {
            return !this.disabled && !this.hidden && !this.readOnly;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "path", {
          get: function () {
            return this.parent.path + "/" + this.name;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "fieldref", {
          get: function () {
            return m(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "value", {
          get: function () {
            return this.state.getValue(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "addMode", {
          get: function () {
            return this.parent.addMode;
          },
          enumerable: !0,
          configurable: !0
        }), k([c.computed, B("design:type", Boolean), B("design:paramtypes", [])], t.prototype, "disabled", null), k([c.computed, B("design:type", Boolean), B("design:paramtypes", [])], t.prototype, "hidden", null), k([c.computed, B("design:type", Boolean), B("design:paramtypes", [])], t.prototype, "readOnly", null), k([c.computed, B("design:type", Boolean), B("design:paramtypes", [])], t.prototype, "inputAllowed", null), k([c.computed, B("design:type", String), B("design:paramtypes", [])], t.prototype, "path", null), k([c.computed, B("design:type", String), B("design:paramtypes", [])], t.prototype, "fieldref", null), k([c.computed, B("design:type", Object), B("design:paramtypes", [])], t.prototype, "value", null), k([c.computed, B("design:type", Boolean), B("design:paramtypes", [])], t.prototype, "addMode", null), t;
      }(A),
      T = function () {
        var e = function (t, n) {
          return (e = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          })(t, n);
        };
        return function (t, n) {
          function r() {
            this.constructor = t;
          }
          e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
        };
      }(),
      M = function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      q = function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      W = function (e) {
        function t(t, n, r, o, i) {
          var a = e.call(this) || this;
          return a.state = t, a.definition = n, a.groupDefinition = r, a.parent = o, a._addMode = !1, a.index = i, a.formAccessor = new Y(t, n, r, a, !1), a;
        }
        return T(t, e), t.prototype.dispose = function () {}, t.prototype.clear = function () {
          return this.formAccessor.flatAccessors.forEach(function (e) {
            e.clear();
          }), this.parent.removeIndex(this.index);
        }, Object.defineProperty(t.prototype, "disabled", {
          get: function () {
            return !!this.parent.disabled || this.state.isDisabledFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "hidden", {
          get: function () {
            return !!this.parent.hidden || this.state.isHiddenFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "readOnly", {
          get: function () {
            return !!this.parent.readOnly || this.state.isReadOnlyFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "inputAllowed", {
          get: function () {
            return !this.disabled && !this.hidden && !this.readOnly;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "path", {
          get: function () {
            return this.parent.path + "/" + this.index;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "fieldref", {
          get: function () {
            return m(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "value", {
          get: function () {
            return this.state.getValue(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.setIndex = function (e) {
          this.index = e;
        }, t.prototype.setAddMode = function () {
          this._addMode = !0;
        }, Object.defineProperty(t.prototype, "addMode", {
          get: function () {
            return this._addMode || this.parent.addMode;
          },
          enumerable: !0,
          configurable: !0
        }), M([c.observable, q("design:type", Number)], t.prototype, "index", void 0), M([c.observable, q("design:type", Boolean)], t.prototype, "_addMode", void 0), M([c.computed, q("design:type", Boolean), q("design:paramtypes", [])], t.prototype, "disabled", null), M([c.computed, q("design:type", Boolean), q("design:paramtypes", [])], t.prototype, "hidden", null), M([c.computed, q("design:type", Boolean), q("design:paramtypes", [])], t.prototype, "readOnly", null), M([c.computed, q("design:type", Boolean), q("design:paramtypes", [])], t.prototype, "inputAllowed", null), M([c.computed, q("design:type", String), q("design:paramtypes", [])], t.prototype, "path", null), M([c.computed, q("design:type", String), q("design:paramtypes", [])], t.prototype, "fieldref", null), M([c.computed, q("design:type", Object), q("design:paramtypes", [])], t.prototype, "value", null), M([c.action, q("design:type", Function), q("design:paramtypes", [Number]), q("design:returntype", void 0)], t.prototype, "setIndex", null), M([c.action, q("design:type", Function), q("design:paramtypes", []), q("design:returntype", void 0)], t.prototype, "setAddMode", null), M([c.computed, q("design:type", Boolean), q("design:paramtypes", [])], t.prototype, "addMode", null), t;
      }(A),
      N = function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      G = function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      U = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      z = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      H = function () {
        function e(e, t, n, r) {
          this.state = e, this.repeatingForm = t, this.parent = n, this.repeatingFormIndexedAccessors = c.observable.map(), this.name = r;
        }
        return e.prototype.dispose = function () {}, e.prototype.clear = function () {}, Object.defineProperty(e.prototype, "path", {
          get: function () {
            return this.parent.path + "/" + this.name;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "fieldref", {
          get: function () {
            return m(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "value", {
          get: function () {
            return this.state.getValue(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "context", {
          get: function () {
            return this.state.context;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.validate = function (e) {
          return U(this, void 0, void 0, function () {
            var t, n, r, o, i;
            return z(this, function (a) {
              switch (a.label) {
                case 0:
                  for (t = [], n = 0, r = this.accessors; n < r.length; n++) o = r[n], t.push(o.validate(e));
                  return [4, Promise.all(t)];
                case 1:
                  return i = a.sent(), null != e && e.ignoreGetError || i.push(void 0 === this.errorValue), [2, i.every(function (e) {
                    return e;
                  })];
              }
            });
          });
        }, Object.defineProperty(e.prototype, "addMode", {
          get: function () {
            return this.parent.addMode;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isValid", {
          get: function () {
            return this.accessors.every(function (e) {
              return e.isValid;
            });
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.initialize = function () {
          var e = this,
            t = 0;
          this.state.getValue(this.path).forEach(function () {
            e.createFormIndexedAccessor(t), t++;
          });
        }, e.prototype.createFormIndexedAccessor = function (e) {
          var t = new W(this.state, this.repeatingForm.definition, this.repeatingForm.groupDefinition, this, e);
          this.repeatingFormIndexedAccessors.set(e, t), t.initialize();
        }, e.prototype.index = function (e) {
          var t = this.repeatingFormIndexedAccessors.get(e);
          if (null == t) throw new Error(e + " is not a RepeatingFormIndexedAccessor");
          return t;
        }, Object.defineProperty(e.prototype, "disabled", {
          get: function () {
            return !!this.parent.disabled || this.state.isDisabledFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "hidden", {
          get: function () {
            return !!this.parent.hidden || this.state.isHiddenFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "readOnly", {
          get: function () {
            return !!this.parent.readOnly || this.state.isReadOnlyFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "inputAllowed", {
          get: function () {
            return !this.disabled && !this.hidden && !this.readOnly;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "accessors", {
          get: function () {
            for (var e = Array.from(this.repeatingFormIndexedAccessors.values()).length, t = [], n = 0; n < e; n++) t.push(this.repeatingFormIndexedAccessors.get(n));
            return t;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "flatAccessors", {
          get: function () {
            var e = [];
            return this.accessors.forEach(function (t) {
              e.push.apply(e, t.flatAccessors), e.push(t);
            }), e;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.accessBySteps = function (e) {
          var t = e[0],
            n = e.slice(1),
            r = parseInt(t, 10);
          if (isNaN(r)) throw new Error("Expected index of repeating form");
          return this.index(r).accessBySteps(n);
        }, e.prototype.insert = function (e, t) {
          var n = this.path + "/" + e;
          Object(p.applyPatch)(this.state.node, [{
            op: "add",
            path: n,
            value: t
          }]), this.index(e).setAddMode();
        }, e.prototype.push = function (e) {
          var t = this.value.length,
            n = this.path + "/" + t;
          Object(p.applyPatch)(this.state.node, [{
            op: "add",
            path: n,
            value: e
          }]), this.index(t).setAddMode();
        }, e.prototype.remove = function (e) {
          var t = this.value.indexOf(e);
          if (-1 === t) throw new Error("Cannot find node to remove.");
          Object(p.applyPatch)(this.state.node, [{
            op: "remove",
            path: this.path + "/" + t
          }]);
        }, e.prototype.removeIndex = function (e) {
          var t = this.repeatingFormIndexedAccessors;
          if (t.delete(e)) {
            var n = [],
              r = [];
            t.forEach(function (t, o) {
              o <= e || (t.setIndex(o - 1), n.push(o), r.push(t));
            }), this.executeRenumber(n, r);
          }
        }, e.prototype.addIndex = function (e) {
          var t = [],
            n = [];
          this.repeatingFormIndexedAccessors.forEach(function (r, o) {
            o < e || (r.setIndex(o + 1), t.push(o), n.push(r));
          }), this.executeRenumber(t, n), this.createFormIndexedAccessor(e);
        }, e.prototype.executeRenumber = function (e, t) {
          var n = this.repeatingFormIndexedAccessors;
          e.forEach(function (e) {
            n.delete(e);
          }), t.forEach(function (e) {
            n.set(e.index, e);
          });
        }, Object.defineProperty(e.prototype, "length", {
          get: function () {
            return this.value.length;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "errorValue", {
          get: function () {
            return this.state.getErrorFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "error", {
          get: function () {
            return this.errorValue;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "warningValue", {
          get: function () {
            return this.state.getWarningFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "warning", {
          get: function () {
            return this.warningValue;
          },
          enumerable: !0,
          configurable: !0
        }), N([c.observable, G("design:type", Map)], e.prototype, "repeatingFormIndexedAccessors", void 0), N([c.computed, G("design:type", String), G("design:paramtypes", [])], e.prototype, "path", null), N([c.computed, G("design:type", String), G("design:paramtypes", [])], e.prototype, "fieldref", null), N([c.computed, G("design:type", Object), G("design:paramtypes", [])], e.prototype, "value", null), N([c.computed, G("design:type", Object), G("design:paramtypes", [])], e.prototype, "context", null), N([c.computed, G("design:type", Boolean), G("design:paramtypes", [])], e.prototype, "addMode", null), N([c.computed, G("design:type", Boolean), G("design:paramtypes", [])], e.prototype, "isValid", null), N([c.computed, G("design:type", Boolean), G("design:paramtypes", [])], e.prototype, "disabled", null), N([c.computed, G("design:type", Boolean), G("design:paramtypes", [])], e.prototype, "hidden", null), N([c.computed, G("design:type", Boolean), G("design:paramtypes", [])], e.prototype, "readOnly", null), N([c.computed, G("design:type", Boolean), G("design:paramtypes", [])], e.prototype, "inputAllowed", null), N([c.computed, G("design:type", Array), G("design:paramtypes", [])], e.prototype, "accessors", null), N([c.computed, G("design:type", Array), G("design:paramtypes", [])], e.prototype, "flatAccessors", null), N([c.computed, G("design:type", Number), G("design:paramtypes", [])], e.prototype, "length", null), N([c.computed, G("design:type", Object), G("design:paramtypes", [])], e.prototype, "errorValue", null), N([c.computed, G("design:type", Object), G("design:paramtypes", [])], e.prototype, "error", null), N([c.computed, G("design:type", Object), G("design:paramtypes", [])], e.prototype, "warningValue", null), N([c.computed, G("design:type", Object), G("design:paramtypes", [])], e.prototype, "warning", null), e;
      }(),
      Z = function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      J = function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      L = function () {
        function e(e, t, n, r) {
          this.state = e, this.definition = t, this.parent = n, this.group = r;
        }
        return Object.defineProperty(e.prototype, "isValid", {
          get: function () {
            var e = this.group.options.include,
              t = this.group.options.exclude;
            if (null != e && null != t) throw new Error("Cannot include and exclude fields at the same time.");
            if (null != e) return this.isValidForNames(e);
            if (null != t) return this.isValidForNames(this.notExcluded(t));
            throw new Error("Must include or exclude some fields");
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.notExcluded = function (e) {
          return this.parent.keys.filter(function (t) {
            return !e.includes(t);
          });
        }, e.prototype.isValidForNames = function (e) {
          var t = this;
          return e.every(function (e) {
            var n = t.parent.access(e);
            return null == n || n.isValid;
          });
        }, Z([c.computed, J("design:type", Boolean), J("design:paramtypes", [])], e.prototype, "isValid", null), e;
      }(),
      $ = function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      K = function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      Q = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      X = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      Y = function () {
        function e(e, t, n, r, o) {
          this.state = e, this.definition = t, this.groupDefinition = n, this.parent = r, this.fieldAccessors = c.observable.map(), this.repeatingFormAccessors = c.observable.map(), this.subFormAccessors = c.observable.map(), this.groupAccessors = c.observable.map(), this.keys = Object.keys(this.definition), this._addMode = o, this.initialize();
        }
        return e.prototype.validate = function (e) {
          return Q(this, void 0, void 0, function () {
            var t, n;
            return X(this, function (r) {
              switch (r.label) {
                case 0:
                  return t = this.accessors.map(function (t) {
                    return t.validate(e);
                  }), [4, Promise.all(t)];
                case 1:
                  return n = r.sent(), null != e && e.ignoreGetError || n.push(void 0 === this.errorValue), [2, n.every(function (e) {
                    return e;
                  })];
              }
            });
          });
        }, e.prototype.dispose = function () {}, e.prototype.clear = function () {}, Object.defineProperty(e.prototype, "disabled", {
          get: function () {
            return !(null == this.parent || !this.parent.disabled) || this.state.isDisabledFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "hidden", {
          get: function () {
            return !(null == this.parent || !this.parent.hidden) || this.state.isHiddenFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "readOnly", {
          get: function () {
            return !(null == this.parent || !this.parent.readOnly) || this.state.isReadOnlyFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "inputAllowed", {
          get: function () {
            return !this.disabled && !this.hidden && !this.readOnly;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "path", {
          get: function () {
            return null == this.parent ? "" : this.parent.path;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "fieldref", {
          get: function () {
            return m(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "value", {
          get: function () {
            return this.state.getValue(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "context", {
          get: function () {
            return this.state.context;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isValid", {
          get: function () {
            return this.accessors.every(function (e) {
              return e.isValid;
            });
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "accessors", {
          get: function () {
            var e = this,
              t = [];
            return this.keys.forEach(function (n) {
              var r = e.definition[n];
              r instanceof _e ? t.push(e.field(n)) : r instanceof ke ? t.push(e.repeatingForm(n)) : r instanceof Ve && t.push(e.subForm(n));
            }), t;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "flatAccessors", {
          get: function () {
            var e = [];
            return this.accessors.forEach(function (t) {
              t instanceof R ? e.push(t) : t instanceof H ? (e.push.apply(e, t.flatAccessors), e.push(t)) : t instanceof I && (e.push.apply(e, t.flatAccessors), e.push(t));
            }), e;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "addMode", {
          get: function () {
            return !!this._addMode || null != this.parent && this.parent.addMode;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.access = function (e) {
          if (this.keys.includes(e)) try {
            return this.field(e);
          } catch (t) {
            try {
              return this.repeatingForm(e);
            } catch (t) {
              try {
                return this.subForm(e);
              } catch (e) {
                return;
              }
            }
          }
        }, e.prototype.accessBySteps = function (e) {
          if (0 === e.length) return this;
          var t = e[0],
            n = e.slice(1),
            r = this.access(t);
          return 0 === n.length ? r : void 0 === r ? r : r.accessBySteps(n);
        }, e.prototype.initialize = function () {
          var e = this;
          this.keys.forEach(function (t) {
            var n = e.definition[t];
            n instanceof _e ? e.createField(t, n) : n instanceof ke ? e.createRepeatingForm(t, n) : n instanceof Ve && e.createSubForm(t, n);
          }), null != this.groupDefinition && Object.keys(this.groupDefinition).forEach(function (t) {
            var n = e.groupDefinition[t];
            e.createGroup(t, n);
          });
        }, e.prototype.createField = function (e, t) {
          var n = new R(this.state, t, this, e);
          this.fieldAccessors.set(e, n);
        }, e.prototype.field = function (e) {
          var t = this.fieldAccessors.get(e);
          if (null == t) throw new Error(e + " is not a Field");
          return t;
        }, e.prototype.createRepeatingForm = function (e, t) {
          var n = new H(this.state, t, this, e);
          this.repeatingFormAccessors.set(e, n), n.initialize();
        }, e.prototype.repeatingForm = function (e) {
          var t = this.repeatingFormAccessors.get(e);
          if (null == t) throw new Error(e + " is not a RepeatingForm");
          return t;
        }, e.prototype.createSubForm = function (e, t) {
          var n = new I(this.state, t.definition, t.groupDefinition, this, e);
          this.subFormAccessors.set(e, n), n.initialize();
        }, e.prototype.subForm = function (e) {
          var t = this.subFormAccessors.get(e);
          if (null == t) throw new Error(e + " is not a SubForm");
          return t;
        }, e.prototype.createGroup = function (e, t) {
          var n = new L(this.state, this.definition, this, t);
          this.groupAccessors.set(e, n);
        }, e.prototype.group = function (e) {
          var t = this.groupAccessors.get(e);
          if (null == t) throw new Error(e + " is not a Group");
          return t;
        }, e.prototype.repeatingField = function (e) {}, Object.defineProperty(e.prototype, "errorValue", {
          get: function () {
            return this.state.getErrorFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "error", {
          get: function () {
            return this.errorValue;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "warningValue", {
          get: function () {
            return this.state.getWarningFunc(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "warning", {
          get: function () {
            return this.warningValue;
          },
          enumerable: !0,
          configurable: !0
        }), $([c.observable, K("design:type", Boolean)], e.prototype, "_addMode", void 0), $([c.computed, K("design:type", Boolean), K("design:paramtypes", [])], e.prototype, "disabled", null), $([c.computed, K("design:type", Boolean), K("design:paramtypes", [])], e.prototype, "hidden", null), $([c.computed, K("design:type", Boolean), K("design:paramtypes", [])], e.prototype, "readOnly", null), $([c.computed, K("design:type", Boolean), K("design:paramtypes", [])], e.prototype, "inputAllowed", null), $([c.computed, K("design:type", String), K("design:paramtypes", [])], e.prototype, "path", null), $([c.computed, K("design:type", String), K("design:paramtypes", [])], e.prototype, "fieldref", null), $([c.computed, K("design:type", Object), K("design:paramtypes", [])], e.prototype, "value", null), $([c.computed, K("design:type", Object), K("design:paramtypes", [])], e.prototype, "context", null), $([c.computed, K("design:type", Boolean), K("design:paramtypes", [])], e.prototype, "isValid", null), $([c.computed, K("design:type", Array), K("design:paramtypes", [])], e.prototype, "accessors", null), $([c.computed, K("design:type", Array), K("design:paramtypes", [])], e.prototype, "flatAccessors", null), $([c.computed, K("design:type", Boolean), K("design:paramtypes", [])], e.prototype, "addMode", null), $([c.computed, K("design:type", Object), K("design:paramtypes", [])], e.prototype, "errorValue", null), $([c.computed, K("design:type", Object), K("design:paramtypes", [])], e.prototype, "error", null), $([c.computed, K("design:type", Object), K("design:paramtypes", [])], e.prototype, "warningValue", null), $([c.computed, K("design:type", Object), K("design:paramtypes", [])], e.prototype, "warning", null), e;
      }(),
      ee = "-",
      te = ".",
      ne = ",",
      re = " ",
      oe = "0",
      ie = new RegExp("\\d"),
      ae = new RegExp("\\s");
    function se(e) {
      return ie.test(e);
    }
    function ue(e) {
      return ae.test(e);
    }
    var ce = function () {
      return function (e, t) {
        this.type = e, this.value = t;
      };
    }();
    function pe(e, t) {
      if (0 === e.length) return e;
      var n = e.split("."),
        r = 2 === n.length ? n[0] : e,
        o = 2 === n.length ? n[1] : "",
        i = "-" === r[0];
      i && (r = r.slice(1)), r = t.renderThousands ? function (e, t) {
        return e.replace(/\B(?=(\d{3})+(?!\d))/g, t);
      }(r, t.thousandSeparator) : r, o = function (e, t) {
        return e.slice(0, t);
      }(o, t.decimalPlaces), t.addZeroes && (o = function (e, t) {
        return e + "0".repeat(t - e.length);
      }(o, t.decimalPlaces));
      var a = o.length > 0 ? r + t.decimalSeparator + o : r;
      return i ? "-" + a : a;
    }
    function le(e, t) {
      var n = function (e, t) {
        for (var n = [], r = 0, o = e; r < o.length; r++) {
          var i = o[r];
          if ("-" === i) n.push(new ce(ee, i));else if (i === t.decimalSeparator) n.push(new ce(te, te));else if (i === t.thousandSeparator) n.push(new ce(ne, ne));else if (se(i)) n.push(new ce(oe, i));else {
            if (!ue(i)) return;
            n.push(new ce(re, i));
          }
        }
        return n;
      }(e, t);
      if (null == n) throw new Error("Unknown tokens");
      if (new de(n, t).parse(), function (e) {
        for (var t = 0, n = 0, r = e; n < r.length; n++) {
          var o = r[n];
          if (o.type === oe) t++;else if (o.type === te) break;
        }
        return t;
      }(n) > t.maxWholeDigits) throw new Error("Too many whole digits");
      if (function (e) {
        for (var t = 0, n = !1, r = 0, o = e; r < o.length; r++) {
          var i = o[r];
          i.type !== te ? n && i.type === oe && t++ : n = !0;
        }
        return t;
      }(n) > t.decimalPlaces) throw new Error("Too many decimal places");
      return n.filter(function (e) {
        return e.type !== ne;
      }).map(function (e) {
        return e.value;
      }).join("");
    }
    var de = function () {
      function e(e, t) {
        var n = this;
        this.tokens = e, this.options = t, this.tokenIndex = 0, this.currentToken = void 0, this.nextToken = function () {
          if (n.tokenIndex >= n.tokens.length) n.currentToken = null;else {
            var e = n.tokens[n.tokenIndex];
            n.tokenIndex++, n.currentToken = e;
          }
        }, this.accept = function (e) {
          return null != n.currentToken && n.currentToken.type === e && (n.nextToken(), !0);
        }, this.expect = function (e) {
          if (n.accept(e)) return !0;
          throw new Error("Unexpected symbol: " + n.currentToken);
        };
      }
      return e.prototype.parse = function () {
        if (this.nextToken(), this.decimal(), null != this.currentToken) throw new Error("Could not parse");
      }, e.prototype.decimal = function () {
        this.options.allowNegative && this.accept(ee), this.absoluteDecimal();
      }, e.prototype.absoluteDecimal = function () {
        this.accept(te) ? (this.expect(oe), this.fraction()) : (this.whole(), this.accept(te) && this.fraction());
      }, e.prototype.whole = function () {
        for (this.threeOrLessDigits(); this.accept(ne);) this.threeDigits();
      }, e.prototype.threeOrLessDigits = function () {
        var e = 1;
        for (this.expect(oe); this.accept(oe);) e++;
        if (null != this.currentToken && this.currentToken.type !== te && e > 3) throw new Error("Too many digits");
      }, e.prototype.threeDigits = function () {
        this.expect(oe), this.expect(oe), this.expect(oe);
      }, e.prototype.fraction = function () {
        for (; this.accept(oe););
      }, e;
    }();
    function fe(e, t) {
      return "function" == typeof t ? ye(t(e)) : null == t ? {
        maxWholeDigits: 10,
        decimalPlaces: 2,
        allowNegative: !0,
        addZeroes: !0
      } : ye(t);
    }
    function ye(e) {
      return {
        maxWholeDigits: e.maxWholeDigits || 10,
        decimalPlaces: null == e.decimalPlaces ? 2 : e.decimalPlaces,
        allowNegative: null == e.allowNegative || e.allowNegative,
        addZeroes: !!e.addZeroes
      };
    }
    function he(e) {
      if ("." === e.thousandSeparator && null == e.decimalSeparator) throw new Error("Can't set thousandSeparator to . without setting decimalSeparator.");
      if (e.thousandSeparator === e.decimalSeparator && null != e.thousandSeparator) throw new Error("Can't set thousandSeparator and decimalSeparator to the same value.");
    }
    var ge = function () {
        var e = function (t, n) {
          return (e = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          })(t, n);
        };
        return function (t, n) {
          function r() {
            this.constructor = t;
          }
          e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
        };
      }(),
      be = function () {
        return (be = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      me = function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      ve = function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      },
      we = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      Oe = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      je = function (e) {
        function t(t, n, r) {
          var o = e.call(this) || this;
          o.form = t, o.node = n, o.saveStatus = "before", o.additionalErrorTree = {}, o.noRawUpdate = !1, o._onPatchDisposer = Object(p.onPatch)(n, function (e) {
            "remove" === e.op ? o.removePath(e.path) : "add" === e.op ? o.addPath(e.path) : "replace" === e.op && o.replacePath(e.path);
          });
          var i = null != r && r.addMode || !1;
          if (o.formAccessor = new Y(o, o.form.definition, o.form.groupDefinition, null, i), o.formAccessor.initialize(), null == r) o.saveFunc = Pe, o.isDisabledFunc = function () {
            return !1;
          }, o.isHiddenFunc = function () {
            return !1;
          }, o.isReadOnlyFunc = function () {
            return !1;
          }, o.isRequiredFunc = function () {
            return !1;
          }, o.getErrorFunc = function () {}, o.getWarningFunc = function () {}, o.blurFunc = function () {}, o.extraValidationFunc = function () {
            return !1;
          }, o.validationBeforeSave = "immediate", o.validationAfterSave = "immediate", o.validationPauseDuration = 0, o.focusFunc = null, o.blurFunc = null, o.updateFunc = null, o._context = void 0, o._converterOptions = {}, o._requiredError = "Required";else {
            o.saveFunc = r.save ? r.save : Pe, o.isDisabledFunc = r.isDisabled ? r.isDisabled : function () {
              return !1;
            }, o.isHiddenFunc = r.isHidden ? r.isHidden : function () {
              return !1;
            }, o.isReadOnlyFunc = r.isReadOnly ? r.isReadOnly : function () {
              return !1;
            }, o.isRequiredFunc = r.isRequired ? r.isRequired : function () {
              return !1;
            }, o.getErrorFunc = r.getError ? r.getError : function () {}, o.getWarningFunc = r.getWarning ? r.getWarning : function () {}, o.extraValidationFunc = r.extraValidation ? r.extraValidation : function () {
              return !1;
            };
            var a = r.validation || {};
            o.validationBeforeSave = a.beforeSave || "immediate", o.validationAfterSave = a.afterSave || "immediate", o.validationPauseDuration = a.pauseDuration || 0, o.focusFunc = r.focus ? r.focus : null, o.blurFunc = r.blur ? r.blur : null, o.updateFunc = r.update ? r.update : null, o._context = r.context, o._converterOptions = r.converterOptions || {}, he(o._converterOptions), o._requiredError = r.requiredError || "Required";
          }
          return o;
        }
        return ge(t, e), t.prototype.dispose = function () {
          this._onPatchDisposer(), this.formAccessor.flatAccessors.forEach(function (e) {
            e.dispose();
          });
        }, Object.defineProperty(t.prototype, "context", {
          get: function () {
            return this._context;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "path", {
          get: function () {
            return "/";
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "fieldref", {
          get: function () {
            return m(this.path);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "value", {
          get: function () {
            return this.node;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "stateConverterOptionsWithContext", {
          get: function () {
            return be({
              context: this.context
            }, this._converterOptions);
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.setSaveStatus = function (e) {
          this.saveStatus = e;
        }, t.prototype.setValueWithoutRawUpdate = function (e, t) {
          this.noRawUpdate = !0, Object(p.applyPatch)(this.node, [{
            op: "replace",
            path: e,
            value: t
          }]), this.noRawUpdate = !1;
        }, t.prototype.replacePath = function (e) {
          if (!this.noRawUpdate) {
            var t = this.accessByPath(e);
            void 0 !== t && t instanceof R && t.setRawFromValue();
          }
        }, t.prototype.removePath = function (e) {
          var t;
          try {
            t = this.accessByPath(e);
          } catch (e) {
            return;
          }
          void 0 !== t && t instanceof W && t.clear();
        }, t.prototype.addPath = function (e) {
          var t = d(e);
          if (0 !== t.length) {
            var n = parseInt(t[t.length - 1], 10);
            if (!isNaN(n)) {
              var r = this.accessByPath(function (e) {
                var t = e.join("/");
                return t.startsWith("/") ? t : "/" + t;
              }(t.slice(0, t.length - 1)));
              void 0 !== r && r instanceof H && r.addIndex(n);
            }
          }
        }, t.prototype.save = function (e) {
          return we(this, void 0, void 0, function () {
            var t, n;
            return Oe(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.validate(e)];
                case 1:
                  return t = r.sent(), null != e && e.ignoreRequired ? [4, this.validate()] : [3, 3];
                case 2:
                  r.sent(), r.label = 3;
                case 3:
                  return this.setSaveStatus("rightAfter"), t ? [4, this.saveFunc(this.node)] : [2, !1];
                case 4:
                  return null != (n = r.sent()) ? (this.setErrors(n), [2, !1]) : (this.clearAdditionalErrors(), [2, !0]);
              }
            });
          });
        }, t.prototype.setErrors = function (e) {
          var t = function (e) {
            return JSON.parse(JSON.stringify(e));
          }(e);
          this.flatAccessors.map(function (n) {
            var r = y(e, n.path);
            n instanceof R && null != r && (n.setError(r), h(t, n.path));
          }), this.additionalErrorTree = t;
        }, t.prototype.clearErrors = function () {
          this.additionalErrorTree = {}, this.flatAccessors.map(function (e) {
            e instanceof R && e.clearError();
          });
        }, t.prototype.clearAdditionalErrors = function () {
          this.additionalErrorTree = {};
        }, t.prototype.getValue = function (e) {
          return Object(p.resolvePath)(this.node, e);
        }, Object.defineProperty(t.prototype, "isValidating", {
          get: function () {
            return this.flatAccessors.some(function (e) {
              return e instanceof R && e.isValidating;
            });
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.accessByPath = function (e) {
          var t = d(e);
          return this.accessBySteps(t);
        }, t.prototype.accessBySteps = function (e) {
          return this.formAccessor.accessBySteps(e);
        }, t.prototype.additionalError = function (e) {
          var t = this.additionalErrorTree[e];
          if ("string" == typeof t) return t;
        }, Object.defineProperty(t.prototype, "additionalErrors", {
          get: function () {
            var e = this,
              t = [];
            return Object.keys(this.additionalErrorTree).forEach(function (n) {
              var r = e.additionalErrorTree[n];
              "string" == typeof r && t.push(r);
            }), t.sort(), t;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "isWarningFree", {
          get: function () {
            return void 0 === this.formAccessor.warningValue && !this.flatAccessors.some(function (e) {
              return !!e && void 0 !== e.warningValue;
            });
          },
          enumerable: !0,
          configurable: !0
        }), me([c.observable, ve("design:type", Object)], t.prototype, "additionalErrorTree", void 0), me([c.observable, ve("design:type", String)], t.prototype, "saveStatus", void 0), me([c.computed, ve("design:type", Object), ve("design:paramtypes", [])], t.prototype, "context", null), me([c.computed, ve("design:type", String), ve("design:paramtypes", [])], t.prototype, "path", null), me([c.computed, ve("design:type", String), ve("design:paramtypes", [])], t.prototype, "fieldref", null), me([c.computed, ve("design:type", Object), ve("design:paramtypes", [])], t.prototype, "value", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", [String]), ve("design:returntype", void 0)], t.prototype, "setSaveStatus", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", [String, Object]), ve("design:returntype", void 0)], t.prototype, "setValueWithoutRawUpdate", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", [String]), ve("design:returntype", void 0)], t.prototype, "replacePath", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", [String]), ve("design:returntype", void 0)], t.prototype, "removePath", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", [String]), ve("design:returntype", void 0)], t.prototype, "addPath", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", [Object]), ve("design:returntype", Promise)], t.prototype, "save", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", [Object]), ve("design:returntype", void 0)], t.prototype, "setErrors", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", []), ve("design:returntype", void 0)], t.prototype, "clearErrors", null), me([c.action, ve("design:type", Function), ve("design:paramtypes", []), ve("design:returntype", void 0)], t.prototype, "clearAdditionalErrors", null), me([c.computed, ve("design:type", Boolean), ve("design:paramtypes", [])], t.prototype, "isValidating", null), me([c.computed, ve("design:type", Array), ve("design:paramtypes", [])], t.prototype, "additionalErrors", null), me([c.computed, ve("design:type", Boolean), ve("design:paramtypes", [])], t.prototype, "isWarningFree", null), t;
      }(A);
    function Pe() {
      return we(this, void 0, void 0, function () {
        return Oe(this, function (e) {
          return console.warn("No mstform save function configured"), [2, null];
        });
      });
    }
    var xe = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      Re = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      Fe = new Map(),
      Se = function () {
        function e(e, t, n) {
          this.model = e, this.definition = t, this.groupDefinition = n;
        }
        return Object.defineProperty(e.prototype, "FormStateType", {
          get: function () {
            throw new Error("For introspection");
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.state = function (e, t) {
          var n = function (e) {
              var t = b.get(e);
              return void 0 === t && (t = g++, b.set(e, t)), t;
            }(e),
            r = Fe.get(n);
          null != r && r();
          var o = new je(this, e, t);
          return Fe.set(n, function () {
            return o.dispose();
          }), o;
        }, e;
      }(),
      Ve = function () {
        return function (e, t) {
          this.definition = e, this.groupDefinition = t;
        };
      }(),
      Ee = function () {
        return function (e) {
          this.message = e;
        };
      }(),
      Ae = function () {
        return function (e) {
          this.value = e;
        };
      }(),
      _e = function () {
        function e(e, t) {
          if (this.converter = e, this.options = t, t) {
            if (this.rawValidators = t.rawValidators ? t.rawValidators : [], this.validators = t.validators ? t.validators : [], this.conversionError = t.conversionError || "Could not convert", this.requiredError = t.requiredError || void 0, this.required = t.required || !1, t.fromEvent) {
              if (t.getRaw) throw new Error("Cannot have fromEvent and getRaw defined at same time");
              this.getRaw = function (e) {
                return e.target.value;
              };
            } else this.getRaw = t.getRaw || l;
            this.derivedFunc = t.derived, this.changeFunc = t.change, this.controlled = t.controlled || this.createDefaultControlled(), this.postprocess = !!t.postprocess;
          } else this.rawValidators = [], this.validators = [], this.conversionError = "Could not convert", this.requiredError = void 0, this.required = !1, this.getRaw = l, this.controlled = this.createDefaultControlled(), this.postprocess = !1;
        }
        return e.prototype.createDefaultControlled = function () {
          var e = this;
          return this.getRaw !== l ? function (t) {
            return {
              value: t.raw,
              onChange: function () {
                for (var n = [], r = 0; r < arguments.length; r++) n[r] = arguments[r];
                return t.setRaw(e.getRaw.apply(e, n));
              }
            };
          } : this.converter.defaultControlled;
        }, Object.defineProperty(e.prototype, "RawType", {
          get: function () {
            throw new Error("This is a function to enable type introspection");
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "ValueType", {
          get: function () {
            throw new Error("This is a function to enable type introspection");
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.getConversionError = function (e) {
          return Ce(this.conversionError, e);
        }, e.prototype.isRequired = function (e, t, n) {
          if (e !== this.converter.emptyRaw) return !1;
          if (!this.converter.neverRequired && this.converter.emptyImpossible) return !0;
          var r = null != n && !!n.ignoreRequired;
          return !this.converter.neverRequired && !r && t;
        }, e.prototype.process = function (e, t) {
          return xe(this, void 0, void 0, function () {
            var n, r, o, i, a, s;
            return Re(this, function (u) {
              switch (u.label) {
                case 0:
                  n = 0, r = this.rawValidators, u.label = 1;
                case 1:
                  return n < r.length ? [4, (0, r[n])(e, t.context)] : [3, 4];
                case 2:
                  if ("string" == typeof (s = u.sent()) && s) return [2, new Ee(s)];
                  u.label = 3;
                case 3:
                  return n++, [3, 1];
                case 4:
                  return [4, this.converter.convert(e, t)];
                case 5:
                  if ("ConversionError" === (o = u.sent())) return [2, new Ee(this.getConversionError(t.context))];
                  i = 0, a = this.validators, u.label = 6;
                case 6:
                  return i < a.length ? [4, (0, a[i])(o.value, t.context)] : [3, 9];
                case 7:
                  if ("string" == typeof (s = u.sent()) && s) return [2, new Ee(s)];
                  u.label = 8;
                case 8:
                  return i++, [3, 6];
                case 9:
                  return [2, new Ae(o.value)];
              }
            });
          });
        }, e.prototype.render = function (e, t) {
          return this.converter.render(e, t);
        }, e;
      }(),
      ke = function () {
        return function (e, t) {
          this.definition = e, this.groupDefinition = t;
        };
      }(),
      Be = function () {
        return function (e) {
          this.options = e;
        };
      }();
    function Ce(e, t) {
      return "string" == typeof e ? e : e(t);
    }
    var De = function () {
        var e = function (t, n) {
          return (e = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          })(t, n);
        };
        return function (t, n) {
          function r() {
            this.constructor = t;
          }
          e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
        };
      }(),
      Ie = function () {
        return (Ie = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      Te = function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function u(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, s);
          }
          u((r = r.apply(e, t || [])).next());
        });
      },
      Me = function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      qe = new RegExp("^-?(0|[1-9]\\d*)$"),
      We = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.defaultControlled = r.value, t;
        }
        return De(t, e), t;
      }(u),
      Ne = new We({
        emptyRaw: "",
        emptyValue: "",
        convert: function (e) {
          return e;
        },
        render: function (e) {
          return e;
        },
        preprocessRaw: function (e) {
          return e.trim();
        }
      }),
      Ge = new We({
        emptyRaw: "",
        emptyImpossible: !0,
        convert: function (e, t) {
          he(t);
          try {
            return +le(e, {
              maxWholeDigits: 100,
              decimalPlaces: 100,
              allowNegative: !0,
              addZeroes: !1,
              decimalSeparator: t.decimalSeparator || ".",
              thousandSeparator: t.thousandSeparator || ",",
              renderThousands: t.renderThousands || !1
            });
          } catch (e) {
            throw new a();
          }
        },
        render: function (e, t) {
          return pe(e.toString(), {
            maxWholeDigits: 100,
            decimalPlaces: 100,
            allowNegative: !0,
            addZeroes: !1,
            decimalSeparator: t.decimalSeparator || ".",
            thousandSeparator: t.thousandSeparator || ",",
            renderThousands: t.renderThousands || !1
          });
        },
        preprocessRaw: function (e, t) {
          return e.trim();
        }
      }),
      Ue = new We({
        emptyRaw: "",
        emptyImpossible: !0,
        rawValidate: function (e) {
          return qe.test(e);
        },
        convert: function (e) {
          return +e;
        },
        render: function (e) {
          return e.toString();
        },
        preprocessRaw: function (e) {
          return e.trim();
        }
      }),
      ze = new u({
        emptyRaw: !1,
        emptyImpossible: !0,
        convert: function (e) {
          return e;
        },
        render: function (e) {
          return e;
        },
        defaultControlled: r.checked,
        neverRequired: !0
      });
    var He = new u({
        emptyRaw: [],
        emptyValue: c.observable.array([]),
        convert: function (e) {
          return c.observable.array(e);
        },
        render: function (e) {
          return e.slice();
        }
      }),
      Ze = new u({
        emptyRaw: "",
        emptyValue: c.observable.array([]),
        defaultControlled: r.value,
        convert: function (e) {
          var t = e.split("\n").map(function (e) {
            return e.trim();
          });
          return 1 === t.length && "" === t[0] ? c.observable.array([]) : c.observable.array(t);
        },
        render: function (e) {
          return e.join("\n");
        }
      });
    var Je = function () {
      function e(e, t) {
        this.converter = e, this.emptyValue = t, this.defaultControlled = r.value, this.neverRequired = !1, this.emptyRaw = "", this.emptyImpossible = !1;
      }
      return e.prototype.preprocessRaw = function (e, t) {
        return e = e.trim(), this.converter.preprocessRaw(e, t);
      }, e.prototype.convert = function (e, t) {
        return Te(this, void 0, void 0, function () {
          return Me(this, function (n) {
            return "" === e.trim() ? [2, new s(this.emptyValue)] : [2, this.converter.convert(e, t)];
          });
        });
      }, e.prototype.render = function (e, t) {
        return e === this.emptyValue ? "" : this.converter.render(e, t);
      }, e;
    }();
    function Le(e, t, n) {
      return new u({
        emptyRaw: t,
        emptyValue: n,
        convert: function (e) {
          return e !== t ? e : n;
        },
        render: function (e) {
          return e !== n ? e : t;
        },
        defaultControlled: r.object
      });
    }
    var $e = {
      string: Ne,
      number: Ge,
      integer: Ue,
      decimal: function (e) {
        return new We({
          emptyRaw: "",
          emptyImpossible: !0,
          defaultControlled: r.value,
          neverRequired: !1,
          preprocessRaw: function (e) {
            return e.trim();
          },
          convert: function (t, n) {
            he(n);
            var r = fe(n.context, e);
            try {
              return le(t, Ie({}, r, {
                decimalSeparator: n.decimalSeparator || ".",
                thousandSeparator: n.thousandSeparator || ",",
                renderThousands: n.renderThousands || !1
              }));
            } catch (e) {
              throw new a();
            }
          },
          render: function (t, n) {
            var r = fe(n.context, e);
            return pe(t, Ie({}, r, {
              decimalSeparator: n.decimalSeparator || ".",
              thousandSeparator: n.thousandSeparator || ",",
              renderThousands: n.renderThousands || !1
            }));
          }
        });
      },
      boolean: ze,
      textStringArray: Ze,
      stringArray: He,
      maybe: function (e) {
        return e instanceof We ? new Je(e, void 0) : Le(0, null, void 0);
      },
      maybeNull: function (e) {
        return e instanceof We ? new Je(e, null) : Le(0, null, null);
      },
      model: function (e) {
        return new u({
          emptyRaw: null,
          emptyImpossible: !0,
          defaultControlled: r.object,
          neverRequired: !1,
          convert: function (e) {
            if (null == e) throw new Error("Raw should never be null at this point");
            return e;
          },
          render: function (e) {
            return e;
          }
        });
      },
      object: new u({
        emptyRaw: null,
        emptyValue: void 0,
        convert: l,
        render: l
      })
    };
    function Ke(e, t) {
      return function (e, t) {
        if (void 0 === e) return;
        if (0 === t.length) return Xe(e);
        return Qe(e, t);
      }(e, d(t));
    }
    function Qe(e, t) {
      if (void 0 !== e) return "string" == typeof e ? function (e, t) {
        if (t.length > 0) return;
        return e;
      }(e, t) : e instanceof Array ? function (e, t) {
        var n = t[0],
          r = t.slice(1);
        if (!f(n)) return;
        return Qe(e[parseInt(n, 10)], r);
      }(e, t) : e instanceof Object ? function (e, t) {
        if (0 === t.length) return Xe(e);
        var n = t[0],
          r = t.slice(1);
        if (0 === r.length) {
          var o = function (e, t) {
            return Ye(e["__message__" + t]);
          }(e, n);
          if (void 0 !== o) return o;
        }
        return Qe(e[n], r);
      }(e, t) : void 0;
    }
    function Xe(e) {
      if (void 0 !== e && "string" != typeof e && !(e instanceof Array)) return Ye(e.__message__);
    }
    function Ye(e) {
      if (void 0 !== e && "string" == typeof e) return e;
    }
    n.d(t, "Form", function () {
      return Se;
    }), n.d(t, "SubForm", function () {
      return Ve;
    }), n.d(t, "ValidationMessage", function () {
      return Ee;
    }), n.d(t, "ProcessValue", function () {
      return Ae;
    }), n.d(t, "Field", function () {
      return _e;
    }), n.d(t, "RepeatingForm", function () {
      return ke;
    }), n.d(t, "Group", function () {
      return Be;
    }), n.d(t, "errorMessage", function () {
      return Ce;
    }), n.d(t, "ConvertError", function () {
      return a;
    }), n.d(t, "ConversionValue", function () {
      return s;
    }), n.d(t, "CONVERSION_ERROR", function () {
      return "ConversionError";
    }), n.d(t, "Converter", function () {
      return u;
    }), n.d(t, "StringConverter", function () {
      return We;
    }), n.d(t, "converters", function () {
      return $e;
    }), n.d(t, "FieldAccessor", function () {
      return R;
    }), n.d(t, "FormAccessor", function () {
      return Y;
    }), n.d(t, "RepeatingFormAccessor", function () {
      return H;
    }), n.d(t, "RepeatingFormIndexedAccessor", function () {
      return W;
    }), n.d(t, "SubFormAccessor", function () {
      return I;
    }), n.d(t, "currentValidationProps", function () {
      return v;
    }), n.d(t, "setupValidationProps", function () {
      return w;
    }), n.d(t, "controlled", function () {
      return r;
    }), n.d(t, "FormState", function () {
      return je;
    }), n.d(t, "resolveMessage", function () {
      return Ke;
    });
  }]);
});